import { isEmpty } from 'lodash';

import FxState from '../../store-util/FxState';
import { WebSocketEventData } from '../custom-event/types';
import { GatewayRequestType, GatewayResponseSubType, GatewayResponseType } from '../web-socket/types';

import { BaseSymbolSubscriptionService } from './BaseSymbolSubscription.service';
import { FxResponseType, SymbolSubscriptionRequestType } from './types';

/**
 * Foreign Exchange Subscription Service
 */
export class FXSubscriptionService extends BaseSymbolSubscriptionService<SymbolSubscriptionRequestType> {
  private static instance: FXSubscriptionService;

  // Make the constructor private, to have a single instance
  // eslint-disable-next-line no-useless-constructor
  private constructor(token: string) {
    super(token);
  }

  static getInstance(token: string): FXSubscriptionService {
    if (!this.instance) {
      this.instance = new FXSubscriptionService(token);
    }

    return this.instance;
  }

  public handleResponseEvent(event: WebSocketEventData<any>): void {
    if (event.data.messageSubType !== GatewayResponseSubType.AugFxQuote) {
      return;
    }

    const arrayData = event.data.arrayData;

    if (isEmpty(arrayData)) { // There is no valid FX response
      return;
    }

    const rawData = arrayData[1];
    if (isEmpty(rawData)) { // There is no valid FX response
      return;
    }

    const rows = rawData[3];
    const symbol = rawData[2];

    if (!symbol || isEmpty(rows)) { // rows and symbol are required
      return;
    }

    const lastRow = rows.pop();
    const mappedRows: FxResponseType = {
      fixTime: lastRow[0],
      bidPrice: lastRow[1],
      bidSize: lastRow[2],
      askPrice: lastRow[3],
      askSize: lastRow[4],
    };

    FxState.setSubscriptionPrices(symbol, mappedRows);
  }

  protected getResponseType(): GatewayResponseType {
    return GatewayResponseType.FXSubscription;
  }

  protected getSubscriptionRequestType(): GatewayRequestType {
    return GatewayRequestType.AugFXSubscription;
  }

  protected getUnsubscriptionRequestType(): GatewayRequestType {
    return GatewayRequestType.AugFXUnsubscription;
  }
}

